<ng-container *ngIf="data.widget=='inline'; else notInline">
    <div class='flex w-full' *ngIf="!data.skeletonLoading; else skeletonLoadingInlineWidget">
        <div class="flex-c-c relative item relative" style="width: 70px;">
            <div class="image100 circular">
                <div class="absoluteFull bgImageFull circular o-60"
                    [lazyLoad]="global.cropImage(artist.profile.profile_pic, 300)"
                    defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-user.png"
                    title="{{artist.profile.full_name}} Profile Picture"></div>
                <img [lazyLoad]="global.cropImage(artist.profile.profile_pic, 300)"
                    defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-user.png"
                    alt="{{artist.profile.full_name}} Profile Picture">
            </div>
        </div>
        <div class='flex-fs-c flex-wrap m-l-10' style='max-width: calc(100% - 80px)'>
            <div style="width: 240px;">
                <a (click)="global.trackEvent('artist-widget', 'Artist-Name', artist.profile.slug_username)"
                    routerLink="/{{artist.profile.slug_username}}" class="w-full text-ellipsis"
                    title="">{{artist.profile.full_name}}&nbsp;</a>
                <a *ngIf="artist.artist_type.length>0" class="w-full text-ellipsis text-xs text-muted p-r-5">
                    <ng-container *ngFor="let type of artist.artist_type; let i=index;">{{(i>0)?',
                        ':''}}{{type}}</ng-container>&nbsp;
                </a>
                <a *ngIf="artist.artist_type.length==0"
                    class="w-full text-ellipsis text-xs text-muted">{{(artist.is_type=='List')?'Listener':artist.is_type}}</a>
                <a *ngIf="artist.is_type!='Listener'"
                    class="w-full text-ellipsis text-xs text-muted">{{artist.songs_count}}
                    {{(artist.songs_count==1)?'Song':'Songs'}}, {{artist.videos_count}}
                    {{(artist.videos_count==1)?'Video':'Videos'}}&nbsp;</a>
            </div>

            <div style="width: calc(100% - 240px); min-width: 100px;"
                *ngIf="(user.status==0 || !artist.is_same_artist); else emptyFollow" class="m-t-10">
                <a class='unfollow-btn' *ngIf="user.status==0; else loggedinUser"
                    (click)="global.trackEvent('artist-widget', 'Follow-Button-Login', artist.profile.slug_username); dialog.openLoginDialog(1,'action','follow')"
                    title='Follow'>Follow</a>
                <ng-template #loggedinUser>
                    <a class='follow-btn' *ngIf="artist.is_following"
                        (click)="global.trackEvent('artist-widget', 'Follow-Button', artist.profile.slug_username); followArtist('unfollow')"
                        [class.disabled]="followLoading" title='Unfollow'>Following</a>
                    <a class='unfollow-btn' *ngIf="!artist.is_following"
                        (click)="global.trackEvent('artist-widget', 'Follow-Button', artist.profile.slug_username); followArtist('follow')"
                        [class.disabled]="followLoading" title='Follow'>Follow</a>
                </ng-template>
            </div>
            <ng-template #emptyFollow>
                <div style="width: calc(100% - 240px); min-width: 100px; height: 30px">
                </div>
            </ng-template>
        </div>
    </div>
    <ng-template #skeletonLoadingInlineWidget>
        <div class="flex-fs-c w-full">
            <div class="flex-c-c relative item relative" style='width: 70px;'>
                <div class="image100 circular skeletonLoading"></div>
            </div>
            <div class='m-l-10' style='width: calc(100% - 80px)'>
                <div class="skeletonLoading w-70 h-15"></div>
                <div class="skeletonLoading w-120 h-15 m-t-10"></div>
                <div class="skeletonLoading w-70 h-15 m-t-10"></div>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #notInline>
    <div class='p-0-10 p-t-10'>
        <div class="item" *ngIf="!data.skeletonLoading; else skeletonLoadingWidget">
            <div class="pos-rlt">
                <div class="image100 circular">
                    <div class="absoluteFull bgImageFull circular o-60"
                        [lazyLoad]="global.cropImage(artist.profile.profile_pic, 200)"
                        defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-user.png"
                        title="{{artist.profile.full_name}} Profile Picture"></div>
                    <img [lazyLoad]="global.cropImage(artist.profile.profile_pic, 200)"
                        defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-user.png"
                        alt="{{artist.profile.full_name}} Profile Picture">

                    <div class="item-overlay opacity r r-2x bg-black">
                        <div *ngIf="user.status==0 || !artist.is_same_artist" class="center text-center m-t-n">
                            <a *ngIf="user.status==0; else loggedinUser"
                                (click)="global.trackEvent('artist-widget', 'Follow-Image-Login', artist.profile.slug_username); dialog.openLoginDialog(1,'action','follow')">
                                <i class="icon-user-follow i-2x pointer" title='Follow'></i>
                            </a>
                            <ng-template #loggedinUser>
                                <a *ngIf="artist.is_following"
                                    (click)="global.trackEvent('artist-widget', 'Follow-Image', artist.profile.slug_username); followArtist('unfollow')"
                                    [class]="(followLoading)?'disabled':''">
                                    <i class="icon-user-following i-2x pointer" title='Unfollow'></i>
                                </a>
                                <a *ngIf="!artist.is_following"
                                    (click)="global.trackEvent('artist-widget', 'Follow-Image', artist.profile.slug_username); followArtist('follow')"
                                    [class]="(followLoading)?'disabled':''">
                                    <i class="icon-user-follow i-2x pointer" title='Follow'></i>
                                </a>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="padder-v flex-col-sb-c t-c">
                <a (click)="global.trackEvent('artist-widget', 'Artist-Name', artist.profile.slug_username)"
                    routerLink="/{{artist.profile.slug_username}}" class="w-full text-ellipsis v-title"
                    title="">{{artist.profile.full_name}}&nbsp;</a>
                <a *ngIf="artist.artist_type.length>0" class="w-full text-ellipsis text-xs text-muted w-full t-c mt-2">
                    <ng-container *ngFor="let type of artist.artist_type; let i=index;">{{(i>0)?',
                        ':''}}{{type}}</ng-container>&nbsp;
                </a>
                <a *ngIf="artist.artist_type.length==0"
                    class="w-full text-ellipsis text-xs text-muted">{{(artist.is_type=='List')?'Listener':artist.is_type}}</a>
                <!-- <a *ngIf="artist.is_type!='Listener'" class="w-full text-ellipsis text-xs text-muted">{{artist.songs_count}} {{(artist.songs_count==1)?'Song':'Songs'}}, {{artist.videos_count}} {{(artist.videos_count==1)?'Video':'Videos'}}</a> -->

                <div *ngIf="(user.status==0 || !artist.is_same_artist); else emptyFollow" class="m-t-10">
                    <a class='unfollow-btn' *ngIf="user.status==0; else loggedinUser"
                        (click)="global.trackEvent('artist-widget', 'Follow-Button-Login', artist.profile.slug_username); dialog.openLoginDialog(1,'action','follow')"
                        title='Follow'>Follow</a>
                    <ng-template #loggedinUser>
                        <a class='follow-btn' *ngIf="artist.is_following"
                            (click)="global.trackEvent('artist-widget', 'Follow-Button', artist.profile.slug_username); followArtist('unfollow')"
                            [class.disabled]="followLoading" title='Unfollow'>Following</a>
                        <a class='unfollow-btn' *ngIf="!artist.is_following"
                            (click)="global.trackEvent('artist-widget', 'Follow-Button', artist.profile.slug_username); followArtist('follow')"
                            [class.disabled]="followLoading" title='Follow'>Follow</a>
                    </ng-template>
                </div>
                <ng-template #emptyFollow>
                    <div class='m-t-10' style="height: 30px">&nbsp;</div>
                </ng-template>
            </div>
        </div>

        <ng-template #skeletonLoadingWidget>
            <div class="item">
                <div class="pos-rlt">
                    <div class="image100 circular skeletonLoading">
                    </div>
                </div>

                <div class="padder-v flex-col-sb-c">
                    <div class='w-100 h-15 skeletonLoading'></div>
                    <div class='w-70 h-15 skeletonLoading m-t-10'></div>
                </div>
            </div>
        </ng-template>
    </div>
</ng-template>
